"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColour = void 0;
exports.getColour = function (n, total) {
    if (total === 6) {
        return ['#c33306', '#fba200', '#d2d015', '#90c221', '#0680c3', '#c306b8'][n];
    }
    if (total === 1) {
        return ['green'][n];
    }
    return "hsl(" + (Math.floor(100 / total * n) + 20) + ",90%,40%)";
};
